import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {AlertActions} from 'presentation/components';
import {AuthorizationsEnum, MyAppointmentsEnum} from 'presentation/constants';
import {useGetEndpointUrl} from 'presentation/hooks';
import {useBookingFlowStepsStore} from 'presentation/modules/booking/shared/store/useBookingFlowStepsStore';
import {ExternalServicesTitlesEnum} from 'presentation/pages/private/hooks/useServicesList/types';
import {translations} from 'presentation/translations-new';

const {authorizations} = translations['pt-br'].privateFlow.therapyBooking.actionText;
const {goToMyAppointments} = translations['pt-br'].privateFlow.bookingFlow;

export function AllScheduledActions() {
	const bookingFlowStep = useBookingFlowStepsStore(state => state.bookingStep);
	const navigate = useNavigate();
	const {pathname} = useLocation();
	const {isLoading} = useGetEndpointUrl(ExternalServicesTitlesEnum.AUTHORIZATION_REQUEST);

	const handleGoToMyAppointments = () => {
		navigate(MyAppointmentsEnum.MY_APPOINTMENTS);
	};

	const handleGetAuthorizations = async () => {
		navigate(AuthorizationsEnum.AUTHORIZATIONS, {
			state: {
				pathname,
				step: bookingFlowStep,
			},
			replace: true,
		});
	};

	return (
		<AlertActions
			flexDirection="column-reverse"
			primaryAction={handleGoToMyAppointments}
			primaryText={goToMyAppointments}
			primaryBtnVariant="contained"
			secondaryAction={handleGetAuthorizations}
			secondaryText={authorizations}
			secondaryBtnVariant="outlined"
			isDisabled={isLoading}
			isLoading={isLoading}
		/>
	);
}
